import { createSelector } from '@reduxjs/toolkit'

import { RootState } from 'src/v2/store/store'

const organizationSwitchState = (state: RootState) => state.organizationSwitch

export const selectOrganizationSwitch = createSelector(
  [organizationSwitchState],
  (organizationSwitch) => organizationSwitch,
)

export const selectOrganizationSwitchStatus = createSelector(
  [organizationSwitchState],
  (organizationSwitch) => organizationSwitch.status,
)

export const selectPendingOrganizationSwitchEvent = createSelector(
  [organizationSwitchState],
  (organizationSwitch) => organizationSwitch.pendingEvent,
)

export const selectIsOrganizationSwitching = createSelector(
  [selectOrganizationSwitchStatus],
  (status) => status === 'switching',
)
